var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _polyline, _polyline2, _polyline3, _polyline4, _path52, _path53, _polyline5, _polyline6, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _line85, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _line100, _line101, _line102, _line103, _line104, _line105, _line106, _line107, _line108, _line109, _line110, _line111, _line112, _line113, _line114, _line115, _line116, _line117, _line118, _line119, _line120, _line121, _line122, _line123, _line124, _line125, _line126, _line127, _line128, _line129, _line130, _line131, _line132, _line133, _line134, _line135, _line136, _line137, _line138, _line139, _line140, _line141, _line142, _line143, _line144, _line145, _line146, _line147, _line148, _line149, _line150, _path54, _path55, _path56, _path57, _rect, _polyline7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectorSide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "820 500 120 70",
    enableBackground: "new 0 0 1920 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M868.85,519.14c-0.35,0-0.64,0.29-0.64,0.64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M903.65,543.59c0,0.39,0.32,0.71,0.71,0.71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M903.21,513.97c0.22,0,0.41-0.12,0.51-0.32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M904.35,513.26c-0.27,0-0.52,0.15-0.63,0.39"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M892.66,513.66c0.1,0.19,0.29,0.32,0.51,0.32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M892.66,513.66c-0.12-0.24-0.37-0.39-0.63-0.39"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M864.81,513.33c0-0.39-0.32-0.71-0.71-0.71"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M863.96,512.62c-0.39,0-0.71,0.32-0.71,0.71"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M857.94,513.33c0-0.39-0.32-0.71-0.71-0.71"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M856.73,512.62c-0.51,0-0.92,0.41-0.92,0.92"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M855.81,544.02c0,0.51,0.41,0.92,0.92,0.92"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M857.23,544.94c0.39,0,0.71-0.32,0.71-0.71"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M863.25,544.23c0,0.39,0.32,0.71,0.71,0.71"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M864.1,544.94c0.39,0,0.71-0.32,0.71-0.71"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M917.11,544.3c0.39,0,0.71-0.32,0.71-0.71"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M889.07,529.84c-0.06,0.13-0.1,0.28-0.1,0.43"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M894.57,533.39c-0.78,0-1.42,0.63-1.42,1.42"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M904.28,533.39c0.47,0,0.85-0.38,0.85-0.85"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M887.7,533.11c0.39,0,0.71-0.32,0.71-0.71"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M888.98,530.84c0,0.55,0.44,0.99,0.99,0.99"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M893.16,522.76c0,0.78,0.63,1.42,1.42,1.42"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M889.97,525.73c-0.55,0-0.99,0.44-0.99,0.99"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M904.57,529.84c0.31,0,0.57-0.25,0.57-0.57"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M905.13,528.29c0-0.31-0.25-0.57-0.57-0.57"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M888.98,527.29c0,0.15,0.03,0.29,0.1,0.43"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M888.41,525.17c0-0.39-0.32-0.71-0.71-0.71"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M905.13,525.03c0-0.47-0.38-0.85-0.85-0.85"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M893.16,521.27c0-1.17-0.95-2.13-2.13-2.13"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M890.89,543.59c0,0.39,0.32,0.71,0.71,0.71"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M892.02,544.3c0.39,0,0.71-0.32,0.71-0.71"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M890.89,542.78c0-0.23-0.19-0.43-0.43-0.43"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M877.78,541.2c0-0.39-0.32-0.71-0.71-0.71"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M877.78,541.64c0,0.39,0.32,0.71,0.71,0.71"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M873.09,541.54c0.5,0,0.99-0.13,1.42-0.38"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M891.6,513.26c-0.39,0-0.71,0.32-0.71,0.71"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M875,516.69c0.43,0.25,0.92,0.38,1.42,0.38"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M863.25,537.71c0,0.39,0.32,0.71,0.71,0.71"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M864.81,515.6c0,0.23,0.19,0.43,0.43,0.43"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M877.78,516.42c0,0.02,0,0.04,0,0.06"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M891.03,538.42c1.17,0,2.13-0.95,2.13-2.13"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M865.24,541.54c-0.23,0-0.43,0.19-0.43,0.43"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M890.46,515.77c0.23,0,0.43-0.19,0.43-0.43"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M893.3,541.72c-0.31,0-0.57,0.25-0.57,0.57"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M878.49,515.77c-0.37,0-0.68,0.28-0.71,0.65"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M876.42,540.49c-0.5,0-0.99,0.13-1.42,0.38"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M863.96,519.14c-0.39,0-0.71,0.32-0.71,0.71"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M877.08,517.07c0.37,0,0.68-0.28,0.71-0.65"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M868.21,537.78c0,0.35,0.29,0.64,0.64,0.64"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M917.82,513.97c0-0.39-0.32-0.71-0.71-0.71"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M903.65,542.28c0-0.31-0.25-0.57-0.57-0.57"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M874.51,516.41c-0.43-0.25-0.92-0.38-1.42-0.38"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 863.25,515.67 863.25,515.68 863.25,515.69 863.25,515.69 863.25,515.7 863.25,515.71 863.25,515.72 863.25,515.73 863.25,515.74  "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 857.94,515.74 857.94,515.73 857.94,515.72 857.94,515.71 857.94,515.7 857.94,515.69 857.94,515.68 857.94,515.68 857.94,515.67  "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 890.89,515.35 890.89,515.35 890.89,515.35 890.89,515.36 890.89,515.36 890.89,515.37 890.89,515.37 890.89,515.37 890.89,515.38  "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 890.89,515.38 890.89,515.39 890.89,515.4 890.89,515.41 890.89,515.41 890.89,515.42 890.89,515.43 890.88,515.44 890.88,515.45  890.88,515.46 890.88,515.47 890.87,515.48 890.87,515.49 890.87,515.5 890.86,515.51 890.86,515.52 890.85,515.53 890.85,515.53  890.85,515.54 890.84,515.55 890.84,515.56 890.83,515.57 890.83,515.58 890.82,515.59 890.81,515.6 890.81,515.6 890.8,515.61  890.79,515.62 890.79,515.63 890.78,515.64 890.77,515.64 890.77,515.65 890.76,515.66 890.75,515.66 890.74,515.67 890.74,515.68  890.73,515.68 890.72,515.69 890.71,515.7 890.7,515.7 890.69,515.71 890.68,515.71 890.68,515.72 890.67,515.72 890.66,515.73  890.65,515.73 890.64,515.74 890.63,515.74 890.62,515.74 890.61,515.75 890.6,515.75 890.59,515.75 890.58,515.76 890.57,515.76  890.56,515.76 890.55,515.76 890.54,515.76 890.54,515.77 890.53,515.77 890.52,515.77 890.51,515.77 890.5,515.77 890.49,515.77  890.48,515.77 890.47,515.77 "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M857.94,541.9l0-0.01 l0-0.01l0-0.01l0-0.01l0-0.01l0-0.01l0-0.01l0-0.01 M863.25,541.82L863.25,541.82l0,0.02l0,0.01l0,0.01l0,0.01l0,0.01l0,0.01l0,0.01  M868.85,523.37l-0.08-0.01l-0.08-0.01l-0.08-0.01l-0.08-0.01l-0.07-0.01l-0.07-0.01l-0.05-0.01l-0.05-0.01l-0.03-0.01l-0.03-0.01 l-0.01-0.01l-0.01-0.01 M868.21,534.31L868.21,534.31l0.01-0.01l0.01-0.01l0.01-0.01l0.02-0.01l0.02-0.01l0.03-0.01l0.03-0.01 l0.03-0.01l0.03-0.01l0.04-0.01l0.04-0.01l0.04-0.01l0.04-0.01l0.05-0.01l0.05-0.01l0.05-0.01l0.05-0.01l0.05-0.01l0.05-0.01"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M905.13,525.73h-0.02 h-0.02h-0.02h-0.02h-0.04h-0.04h-0.05h-0.05h-0.06h-0.06h-0.07h-0.07h-0.08h-0.08h-0.08h-0.08"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 892.66,540.74 892.66,540.75 892.66,540.77 892.66,540.78 892.66,540.8 892.66,540.81 892.66,540.81 892.66,540.82 892.66,540.83  892.66,540.84 892.66,540.84 892.66,540.85 892.66,540.86 892.66,540.89 892.66,540.91 892.66,540.95 892.66,540.98 892.66,541.04  892.66,541.1 892.67,541.15 892.67,541.2 892.67,541.31 892.68,541.42 892.68,541.52 892.69,541.62 892.7,541.71 892.71,541.8  892.71,541.88 892.72,541.96 892.72,542.03 892.73,542.1 892.73,542.16 892.73,542.22 "
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 905.13,531.83 905.12,531.83 905.1,531.83 905.09,531.83 905.07,531.83 905.03,531.83 904.99,531.83 904.94,531.83 904.89,531.83  904.82,531.83 904.76,531.83 904.68,531.83 904.61,531.83 904.53,531.83 904.45,531.83 904.37,531.83 904.28,531.83 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.23,
    y1: 544.94,
    x2: 856.73,
    y2: 544.94
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 542.53,
    x2: 863.25,
    y2: 541.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 544.23,
    x2: 863.25,
    y2: 542.53
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 864.1,
    y1: 544.94,
    x2: 863.96,
    y2: 544.94
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 903.65,
    y1: 542.28,
    x2: 903.65,
    y2: 543.59
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 904.35,
    y1: 537.92,
    x2: 904.35,
    y2: 544.3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 917.82,
    y1: 537.92,
    x2: 917.82,
    y2: 543.59
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 904.35,
    y1: 544.3,
    x2: 917.11,
    y2: 544.3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 855.81,
    y1: 513.55,
    x2: 855.81,
    y2: 518.29
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 856.73,
    y1: 512.62,
    x2: 857.23,
    y2: 512.62
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 515.03,
    x2: 857.94,
    y2: 515.03
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 515.03,
    x2: 857.94,
    y2: 515.67
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 513.33,
    x2: 857.94,
    y2: 515.03
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 515.67,
    x2: 857.94,
    y2: 518.29
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 515.67,
    x2: 863.25,
    y2: 515.03
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 515.03,
    x2: 863.25,
    y2: 513.33
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 518.29,
    x2: 863.25,
    y2: 515.67
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 864.1,
    y1: 512.62,
    x2: 863.96,
    y2: 512.62
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 864.81,
    y1: 515.6,
    x2: 864.81,
    y2: 513.33
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 891.6,
    y1: 513.26,
    x2: 892.02,
    y2: 513.26
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 904.35,
    y1: 513.26,
    x2: 917.11,
    y2: 513.26
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 892.66,
    y1: 513.66,
    x2: 892.66,
    y2: 519.64
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 904.35,
    y1: 513.26,
    x2: 904.35,
    y2: 519.64
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 868.21,
    y1: 519.99,
    x2: 868.21,
    y2: 519.78
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 864.81,
    y1: 518.29,
    x2: 864.81,
    y2: 515.6
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 873.09,
    y1: 516.03,
    x2: 865.24,
    y2: 516.03
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 893.17,
    y1: 513.97,
    x2: 903.21,
    y2: 513.97
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 890.89,
    y1: 513.97,
    x2: 890.89,
    y2: 515.35
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 890.46,
    y1: 515.77,
    x2: 890.47,
    y2: 515.77
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 878.49,
    y1: 515.77,
    x2: 890.46,
    y2: 515.77
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 917.82,
    y1: 513.97,
    x2: 917.82,
    y2: 519.64
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 864.1,
    y1: 519.14,
    x2: 863.96,
    y2: 519.14
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 875,
    y1: 516.69,
    x2: 874.51,
    y2: 516.41
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 877.08,
    y1: 517.07,
    x2: 876.42,
    y2: 517.07
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 892.66,
    y1: 537.92,
    x2: 892.66,
    y2: 540.74
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 892.66,
    y1: 537.66,
    x2: 892.66,
    y2: 537.92
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 893.3,
    y1: 541.72,
    x2: 903.08,
    y2: 541.72
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 917.82,
    y1: 519.64,
    x2: 917.82,
    y2: 537.92
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 537.29,
    x2: 857.94,
    y2: 539.27
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 858.36,
    y1: 537.29,
    x2: 857.94,
    y2: 537.29
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 862.83,
    y1: 537.29,
    x2: 863.25,
    y2: 537.29
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 542.53,
    x2: 863.25,
    y2: 542.53
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 864.23,
    y1: 538.42,
    x2: 867.86,
    y2: 538.42
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 867.86,
    y1: 538.42,
    x2: 868.85,
    y2: 538.42
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 864.81,
    y1: 538.42,
    x2: 864.81,
    y2: 539.27
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 868.21,
    y1: 537.78,
    x2: 868.21,
    y2: 537.57
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 875,
    y1: 540.87,
    x2: 874.51,
    y2: 541.16
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 877.07,
    y1: 540.49,
    x2: 876.42,
    y2: 540.49
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 903.65,
    y1: 542.22,
    x2: 903.65,
    y2: 542.28
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 892.73,
    y1: 542.22,
    x2: 892.73,
    y2: 542.28
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 904.35,
    y1: 533.39,
    x2: 904.35,
    y2: 537.92
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 904.35,
    y1: 519.64,
    x2: 904.35,
    y2: 524.18
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 855.81,
    y1: 518.29,
    x2: 855.81,
    y2: 539.27
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 855.81,
    y1: 544.02,
    x2: 855.81,
    y2: 539.27
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 879.27,
    y1: 519.14,
    x2: 868.85,
    y2: 519.14
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 879.62,
    y1: 519.14,
    x2: 879.27,
    y2: 519.14
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 864.81,
    y1: 519.14,
    x2: 864.81,
    y2: 518.29
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 867.86,
    y1: 519.14,
    x2: 868.85,
    y2: 519.14
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 864.23,
    y1: 519.14,
    x2: 864.1,
    y2: 519.14
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 867.86,
    y1: 519.14,
    x2: 864.23,
    y2: 519.14
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 889.47,
    y1: 519.14,
    x2: 879.62,
    y2: 519.14
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 892.66,
    y1: 519.9,
    x2: 892.66,
    y2: 519.64
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 544.23,
    x2: 857.94,
    y2: 542.53
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 542.53,
    x2: 857.94,
    y2: 541.9
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 529.56,
    x2: 857.94,
    y2: 537.29
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 541.9,
    x2: 857.94,
    y2: 539.27
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 528.85,
    x2: 857.94,
    y2: 529.56
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 862.83,
    y1: 537.29,
    x2: 858.36,
    y2: 537.29
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 858.36,
    y1: 520.28,
    x2: 857.94,
    y2: 520.28
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 862.83,
    y1: 520.28,
    x2: 863.25,
    y2: 520.28
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 862.83,
    y1: 520.28,
    x2: 858.36,
    y2: 520.28
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 518.29,
    x2: 857.94,
    y2: 520.28
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 528.71,
    x2: 857.94,
    y2: 528.85
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 528,
    x2: 857.94,
    y2: 528.71
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 857.94,
    y1: 520.28,
    x2: 857.94,
    y2: 528
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 519.85,
    x2: 863.25,
    y2: 518.29
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 889.83,
    y1: 519.14,
    x2: 889.47,
    y2: 519.14
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 891.03,
    y1: 519.14,
    x2: 889.83,
    y2: 519.14
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 520.28,
    x2: 863.25,
    y2: 519.85
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 528.71,
    x2: 863.25,
    y2: 528
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 528.85,
    x2: 863.25,
    y2: 528.71
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 529.56,
    x2: 863.25,
    y2: 528.85
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 537.29,
    x2: 863.25,
    y2: 529.56
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 537.71,
    x2: 863.25,
    y2: 537.29
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 528,
    x2: 863.25,
    y2: 520.28
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 868.21,
    y1: 535.24,
    x2: 868.21,
    y2: 537.57
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 868.21,
    y1: 522.4,
    x2: 868.21,
    y2: 522.31
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 868.21,
    y1: 534.31,
    x2: 868.21,
    y2: 523.23
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 868.21,
    y1: 519.99,
    x2: 868.21,
    y2: 522.31
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 870.98,
    y1: 524.37,
    x2: 887.7,
    y2: 524.46
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 868.21,
    y1: 523.23,
    x2: 868.21,
    y2: 522.98
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 868.21,
    y1: 522.98,
    x2: 868.21,
    y2: 522.4
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 879.27,
    y1: 538.42,
    x2: 868.85,
    y2: 538.42
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 865.24,
    y1: 541.54,
    x2: 873.09,
    y2: 541.54
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 541.9,
    x2: 863.25,
    y2: 539.27
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.25,
    y1: 539.27,
    x2: 863.25,
    y2: 537.71
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 863.96,
    y1: 538.42,
    x2: 864.1,
    y2: 538.42
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 864.1,
    y1: 538.42,
    x2: 864.23,
    y2: 538.42
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 864.81,
    y1: 544.23,
    x2: 864.81,
    y2: 541.96
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 864.81,
    y1: 541.96,
    x2: 864.81,
    y2: 539.27
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 888.41,
    y1: 525.17,
    x2: 888.41,
    y2: 532.4
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 868.85,
    y1: 523.37,
    x2: 870.98,
    y2: 524.37
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 889.47,
    y1: 538.42,
    x2: 879.62,
    y2: 538.42
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 877.78,
    y1: 541.2,
    x2: 877.78,
    y2: 541.64
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 890.46,
    y1: 542.35,
    x2: 890.52,
    y2: 542.35
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 878.49,
    y1: 542.35,
    x2: 890.46,
    y2: 542.35
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 879.62,
    y1: 538.42,
    x2: 879.27,
    y2: 538.42
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 889.83,
    y1: 538.42,
    x2: 889.47,
    y2: 538.42
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 891.03,
    y1: 538.42,
    x2: 889.83,
    y2: 538.42
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 890.89,
    y1: 542.78,
    x2: 890.89,
    y2: 543.59
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 891.6,
    y1: 544.3,
    x2: 892.02,
    y2: 544.3
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 892.73,
    y1: 542.28,
    x2: 892.73,
    y2: 543.59
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 893.16,
    y1: 522.76,
    x2: 893.16,
    y2: 521.27
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 904.28,
    y1: 524.18,
    x2: 894.57,
    y2: 524.18
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 888.51,
    y1: 527.72,
    x2: 889.07,
    y2: 527.72
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 888.51,
    y1: 529.84,
    x2: 889.07,
    y2: 529.84
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 889.07,
    y1: 529.84,
    x2: 889.97,
    y2: 529.84
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 889.97,
    y1: 529.84,
    x2: 894.36,
    y2: 529.84
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 888.51,
    y1: 527.72,
    x2: 888.48,
    y2: 527.72
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 888.51,
    y1: 529.84,
    x2: 888.48,
    y2: 529.84
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 905.13,
    y1: 526.73,
    x2: 905.13,
    y2: 527.29
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 905.13,
    y1: 528.29,
    x2: 905.13,
    y2: 527.29
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 905.13,
    y1: 526.73,
    x2: 905.13,
    y2: 525.73
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 905.13,
    y1: 525.73,
    x2: 905.13,
    y2: 525.03
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 889.97,
    y1: 525.73,
    x2: 904.28,
    y2: 525.73
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 888.98,
    y1: 527.29,
    x2: 888.98,
    y2: 526.73
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 889.07,
    y1: 527.72,
    x2: 889.97,
    y2: 527.72
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 889.97,
    y1: 527.72,
    x2: 894.36,
    y2: 527.72
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 896.34,
    y1: 527.72,
    x2: 894.36,
    y2: 527.72
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 904.28,
    y1: 527.72,
    x2: 896.34,
    y2: 527.72
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 904.57,
    y1: 527.72,
    x2: 904.28,
    y2: 527.72
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 904.57,
    y1: 529.84,
    x2: 904.28,
    y2: 529.84
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 896.34,
    y1: 529.84,
    x2: 894.36,
    y2: 529.84
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 904.28,
    y1: 529.84,
    x2: 896.34,
    y2: 529.84
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 905.13,
    y1: 528.85,
    x2: 905.13,
    y2: 529.28
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 905.13,
    y1: 528.71,
    x2: 905.13,
    y2: 528.85
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 870.94,
    y1: 533.19,
    x2: 868.85,
    y2: 534.18
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 868.21,
    y1: 535.16,
    x2: 868.21,
    y2: 535.24
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 868.21,
    y1: 534.58,
    x2: 868.21,
    y2: 535.16
  })), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 868.21,
    y1: 534.31,
    x2: 868.21,
    y2: 534.58
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 870.94,
    y1: 533.19,
    x2: 887.7,
    y2: 533.11
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 893.16,
    y1: 534.81,
    x2: 893.16,
    y2: 536.29
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 905.13,
    y1: 531.83,
    x2: 905.13,
    y2: 530.84
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 905.13,
    y1: 531.83,
    x2: 905.13,
    y2: 532.54
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 904.28,
    y1: 533.39,
    x2: 894.57,
    y2: 533.39
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 889.97,
    y1: 531.83,
    x2: 904.28,
    y2: 531.83
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 888.98,
    y1: 530.27,
    x2: 888.98,
    y2: 530.84
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 905.13,
    y1: 530.27,
    x2: 905.13,
    y2: 530.84
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 905.13,
    y1: 530.27,
    x2: 905.13,
    y2: 529.28
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 905.13,
    y1: 528.29,
    x2: 905.13,
    y2: 528.71
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M827.33,526.4c0,0,14.19,0.35,28.24-7.91"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M827.4,527.04c14.19,0,28.31-1.98,28.31-1.98"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M827.33,528.52c0,0,14.19,0.71,28.24,8.96"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M827.4,527.88c14.19,0,28.02,3.11,28.02,3.11"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 802.49,
    y: 524.64,
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 24.78,
    height: 5.93
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 932.51,529.45 963.01,514.21 963.01,544.7 932.51,529.45 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorSide);
export default __webpack_public_path__ + "static/media/connector-side.8dfaefc08e73a501033a69d8a08d25c4.svg";
export { ForwardRef as ReactComponent };